import classNames from 'classnames';
import React from 'react';
import { createPortal } from 'react-dom';
import { OsType } from 'shared/enums/os-type.enum';
import AndroidIcon from 'src/assets/images/icons/default/AndroidIcon';
import AppleIcon from 'src/assets/images/icons/default/AppleIcon';
import { PlatformFilterOsType } from 'src/components/PlatformFilter/platform-filter-props.interface';
import { useTranslationByKey } from 'src/hooks/use-translation-by-key';

interface GamesPlatformPromptProps {
  isOpen: boolean;
  onSelect: (osTypeId: PlatformFilterOsType) => void;
  keepNavigationVisible?: boolean;
  coverDesktopContentPanel?: boolean;
  className?: string;
}

const GamesPlatformPrompt: React.FC<GamesPlatformPromptProps> = ({
  isOpen,
  onSelect,
  keepNavigationVisible = false,
  coverDesktopContentPanel = false,
  className,
}) => {
  const t = useTranslationByKey('PAGES.GAMES_PAGE');

  if (!isOpen) return null;

  const prompt = (
    <div
      className={classNames(
        'flex items-center justify-center bg-white/70 px-4 backdrop-blur-sm',
        coverDesktopContentPanel
          ? 'fixed inset-y-0 right-0 left-[17.5rem] z-40'
          : keepNavigationVisible
            ? 'absolute inset-0 z-[5]'
            : 'absolute inset-0 z-[5]',
        className
      )}
    >
      <div className="w-full max-w-sm rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-xl">
        <h3 className="font-zillaSlab text-2xl font-semibold text-slate-900">{t('PLATFORM_OS_PROMPT_TITLE')}</h3>
        <div className="mt-5 flex justify-center gap-3">
          <button
            type="button"
            onClick={() => onSelect(OsType.Android)}
            className="inline-flex items-center gap-2 rounded-xl border border-[#5b98d1] px-4 py-2 font-manrope text-sm font-semibold text-[#3f54a4] transition hover:bg-blue-50"
          >
            <AndroidIcon className="h-4 w-4" /> Android
          </button>
          <button
            type="button"
            onClick={() => onSelect(OsType.Ios)}
            className="inline-flex items-center gap-2 rounded-xl border border-[#c26a93] px-4 py-2 font-manrope text-sm font-semibold text-[#3f54a4] transition hover:bg-pink-50"
          >
            <AppleIcon className="h-4 w-4" /> iPhone
          </button>
        </div>
      </div>
    </div>
  );

  return coverDesktopContentPanel && typeof document !== 'undefined' ? createPortal(prompt, document.body) : prompt;
};

export default GamesPlatformPrompt;
